import { useTheme } from "next-themes";
import { Link } from "react-router-dom";
import { PageTitle } from "@/components/app/ui";
import { CurrencySelect } from "@/components/CurrencySelect";
import { useAuth } from "@/context/AuthContext";

export default function SettingsPage() {
  const { user, company } = useAuth();
  const { theme, setTheme } = useTheme();
  return (
    <div data-testid="settings-page">
      <PageTitle title="Settings" />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="card-box p-6 space-y-3">
          <h3 className="font-semibold text-lg">Account</h3>
          <div className="text-sm"><span className="text-muted-foreground">Name:</span> {user?.name}</div>
          <div className="text-sm"><span className="text-muted-foreground">Email:</span> {user?.email}</div>
          <div className="text-sm"><span className="text-muted-foreground">Role:</span> {user?.role}</div>
          <div className="text-sm"><span className="text-muted-foreground">Workspace:</span> {company?.name}</div>
          <Link to="/forgot-password" className="btn-ghost !py-2 text-xs" data-testid="settings-change-password">Change password</Link>
        </div>
        <div className="card-box p-6 space-y-5">
          <h3 className="font-semibold text-lg">Preferences</h3>
          <div className="flex items-center justify-between"><span className="text-sm">Theme</span>
            <div className="flex gap-2">{["light", "dark", "system"].map((t) => <button key={t} onClick={() => setTheme(t)} data-testid={`settings-theme-${t}`} className={`rounded-full border px-3 py-1.5 text-xs capitalize ${theme === t ? "bg-[#4f46e5] text-white border-[#4f46e5]" : ""}`}>{t}</button>)}</div>
          </div>
          <div className="flex items-center justify-between"><span className="text-sm">Billing currency</span><CurrencySelect testId="settings-currency-select" /></div>
          <div className="text-xs text-muted-foreground">Sign-in security: a 6-digit email code is required on new devices. Trusted devices skip the code for 30 days. Clearing cookies removes trust.</div>
        </div>
        <div className="card-box p-6 lg:col-span-2 text-sm text-muted-foreground">
          Data & privacy: to export or delete your workspace data (GDPR request), email <a className="underline" href="mailto:legal@sliance.com">legal@sliance.com</a>. See our <Link to="/legal/privacy" className="underline">Privacy Policy</Link>.
        </div>
      </div>
    </div>
  );
}
